module.exports = __webpack_public_path__ + "static/img/oca-environment-report.9310486.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/oca-environment-report.jpg
// module id = 1pr7
// module chunks = 0